import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { Formik } from 'formik';
// material-ui
import { DataGrid } from '@mui/x-data-grid';
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  Grow,
  IconButton,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
// project imports
import { gridSpacing } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import { SearchOutlined } from '@mui/icons-material';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { useNavigate } from 'react-router';
import { baseUrl } from 'store/baseurl';

// ==============================|| DEFAULT DASHBOARD ||============================== //

const CreateBot = (...others) => {
  const theme = useTheme();
  const [errorMessage, setMessage] = useState(true);
  const [IsExist, setIsExist] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [webUrl, setwebUrl] = useState('');
  const [ClientStoreResponse, setClientStoreResponse] = useState('');
  const [open, setOpen] = React.useState(false);
  const [ActivePlan, setActivePlan] = useState(localStorage.getItem("ActivePlan") != null ? JSON.parse(localStorage.getItem("ActivePlan")) : null);
  const [IsIndexError, setIsIndexError] = useState(false);
  const [IsIndexErrorMessage, setIsIndexErrorMessage] = useState("");

  const token = localStorage.getItem('token');
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  // Retrieve the string from sessionStorage
  const userDataString = sessionStorage.getItem("UserData");
  // Parse the string into an object
  const userData = JSON.parse(userDataString);
  const navigate = useNavigate();
  const CreateClientStore = () => {

    handleOpen();
    console.log(selectedRows);
    const listOfUrls = selectedRows.map(url => url.url);
    fetch(`${baseUrl}api/client/CreateClientStore`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        clientid: userData.ClientId,
        weburl: webUrl,
        excludedUrls: listOfUrls,
        planid: ActivePlan.PlanId
      })
    }).then(response => {
      if (!response.ok) {
        if (response.status === "401") {
          navigate('/login', { state: 'Expired' })
        }
        else if (response.status === "403") {
          navigate('/login', { state: 'Expired' })
        }
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
      .then(apiData => {
        //setData(apiData);
        handleClose();
        setIsExist(true)
        if (apiData.success == true) {
          //   navigate("/dashboard");
          // setClientInfo(apiData.data);
          funSetTimeOut();
          const message = apiData.message;
          setClientStoreResponse(apiData.message)
          navigate("/botstore", { state: message });
        }
        else {
          funSetTimeOut();
          console.log(apiData.message)
          setMessage(apiData.message);
        }
      })
      .catch(error => {
        console.log(error)
        setMessage(error.TypeError)
        setIsExist(true)
        funSetTimeOut();

        handleClose();

      })
  }

  useEffect(() => {
  }, []);

  const handleDelete = () => { }


  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'url',
      headerName: 'URL',
      width: 850,
      editable: true,
    },

  ];
  const funSetTimeOut = () => {
    setTimeout(() => {
      setIsExist(false);
    }, 9000);
  }
  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <MainCard>
            {IsExist === true ? (
              <Grid className='my-2'>
                {errorMessage &&
                  <Grow
                    in={IsExist}
                    style={{ transformOrigin: '0 0 0' }}
                    {...(IsExist ? { timeout: 1000 } : {})}
                  >
                    <Alert severity='error' onClose={() => { setIsExist(false) }}>{errorMessage}</Alert>
                  </Grow>
                }
              </Grid>
            )
              : null}

            {IsIndexError === true ? (
              <Grid className='my-2'>
                {IsIndexErrorMessage &&
                  <Grow
                    in={IsIndexError}
                    style={{ transformOrigin: '0 0 0' }}
                    {...(IsIndexError ? { timeout: 1000 } : {})}
                  >
                    <Alert severity='error' onClose={() => { setIsIndexError(false) }}>{IsIndexErrorMessage}</Alert>
                  </Grow>
                }
              </Grid>
            )
              : null}
            <Box>
              <Formik
                initialValues={{
                  url: "",
                  submit: null
                  //onSubmit:{onSubmitMethod}
                }}
                validationSchema={Yup.object().shape({
                  url: Yup.string().url('Url must be valid').max(255).required('Url is required'),
                })}
                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                  handleOpen();
                  setwebUrl(values.url);
                  fetch(`${baseUrl}api/client/sitemap`, {
                    method: 'POST',
                    headers: {
                      'Authorization': `Bearer ${token}`,
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      url: values.url,

                    })
                  }).then(response => {
                    console.log(response);

                    if (!response.ok) {
                      throw new Error('Network response was not ok');
                    }
                    return response.json();
                  })
                    .then(apiData => {

                      //setData(apiData);
                      //sessionStorage.setItem('UserData', JSON.stringify(apiData.data))
                      //localStorage.setItem("userdata", JSON.stringify(apiData.data));
                      handleClose();
                      if (apiData.success == true) {
                        //navigate("/dashboard");
                        setRows(apiData.data);
                        console.log(apiData.data)
                      }
                      else {
                        setIsExist(true)
                        funSetTimeOut();
                        setMessage(apiData.message);
                      }
                    })
                    .catch(error => {
                      console.log(error);
                      setMessage(error);
                    })


                }}
              >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                  <form noValidate onSubmit={handleSubmit} {...others}>
                    <Grid item xs={12} className='d-flex'>
                      <Grid item xs={4}>
                        <FormControl fullWidth error={Boolean(touched.url && errors.url)} sx={{ ...theme.typography.customInput }}>
                          <InputLabel htmlFor="outlined-adornment-url-search">Url</InputLabel>
                          <OutlinedInput
                            id="outlined-adornment-url-search"
                            type="text"
                            value={values.url}
                            name="url"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            label="Url"
                            inputProps={{}}
                          />
                          {touched.url && errors.url && (
                            <FormHelperText error id="standard-weight-helper-text-email-login">
                              {errors.url}
                            </FormHelperText>
                          )}
                        </FormControl>
                        {errors.submit && (
                          <Box sx={{ mt: 3 }}>
                            <FormHelperText error>{errors.submit}</FormHelperText>
                          </Box>
                        )}
                      </Grid>
                      <Grid>
                        <Box sx={{ mt: 0.5, p: 0.5 }}>
                          <AnimateButton>
                            <Button disableElevation disabled={isSubmitting} size="medium" type="submit" variant="contained" className='mx-3' color="secondary">
                              <IconButton size="small">
                                <SearchOutlined sx={{
                                  width: 30, height: 35, color: "white"
                                }}>
                                </SearchOutlined></IconButton>
                              {/* {
                            IsLoading ? (<Circularloading />) : 
                            (<IconButton size="small"> 
                            <SearchOutlined sx={{
                              width: 30, height: 35, color: "white"
                            }}>
                              </SearchOutlined></IconButton>)
                              } */}
                            </Button>
                          </AnimateButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Box>
            <Box sx={{ height: 450, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[10]}
                checkboxSelection
                disableRowSelectionOnClick
                // isRowSelected= {(id) => console.log(boolean)}
                onRowSelectionModelChange={(ids) => {
                  debugger;
                  const selectedIDs = new Set(ids);
                  const selectedRows = rows.filter((row) =>
                    selectedIDs.has(row.id),
                  );
                  if (selectedRows.length < 1) {
                    setIsIndexError(true);
                    setIsIndexErrorMessage(`Please select atleast one link.`);
                  }else{
                    if (selectedRows.length > ActivePlan.Indexallowed) {
                      setIsIndexError(true);
                      setIsIndexErrorMessage(`You can Select only ${ActivePlan.Indexallowed} links`);
                      //setIsExist(true);
                    } else {
                      const unselectedUrls = rows.filter(x => !selectedRows.includes(x));
                      console.log(selectedRows);
                      setSelectedRows(unselectedUrls);
                      setIsIndexError(false);
                      //setIsExist(false);
                    }
                  }
                  

                }}
              />
            </Box>
            <Grid item xs={12} py={4} spacing={4}>
              {rows.length >= 1 && IsIndexError == false ?
                <Button disableElevation size="large" className='mx-5' style={{ float: 'right' }} onClick={CreateClientStore} type="button" variant="contained" color="secondary">
                  Create Client Store
                </Button>
                : null
              }

            </Grid>

          </MainCard>
          {/* <Grid container spacing={gridSpacing}>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <EarningCard isLoading={isLoading} />
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <TotalOrderLineChartCard isLoading={isLoading} />
          </Grid>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <Grid container spacing={gridSpacing}>
              <Grid item sm={6} xs={12} md={6} lg={12}>
                <TotalIncomeDarkCard isLoading={isLoading} />
              </Grid>
              <Grid item sm={6} xs={12} md={6} lg={12}>
                <TotalIncomeLightCard isLoading={isLoading} />
              </Grid>
            </Grid>
          </Grid>
        </Grid> */}
        </Grid>
        {/* <Grid item xs={12}>
        <Grid container spacing={gridSpacing}>
          <Grid item xs={12} md={8}>
            <TotalGrowthBarChart isLoading={isLoading} />
          </Grid>
          <Grid item xs={12} md={4}>
            <PopularCard isLoading={isLoading} />
          </Grid>
        </Grid>
      </Grid> */}
      </Grid>
    </>
  );
};

export default CreateBot; 
